let listeners = [];
let channels = [];

const emitChange = () => {
  listeners.forEach((listener) => listener());
};

export const subscribedChannelsStore = {
  addChannel(channelObj) {
    channels = [...channels, channelObj];
    emitChange();
  },
  subscribe(listener) {
    listeners = [...listeners, listener];
    return () => {
      listeners = listeners.filter((l) => l !== listener);
    };
  },
  getSnapShot() {
    return channels;
  },
};
